import { useState } from "react";
import { useGlobalMessage } from "../context/AppMessageContext";


export default function usePageState() {
  const [isLoading, setLoading] = useState<boolean>(false);
  const messageApi = useGlobalMessage();

  const showMessage = (msg: string, type: "success" | "error" | 'warning' | 'loading' | "info" = "info", duration = 1) => {
    messageApi?.open({
      key: "TUPOTII_USER_GLOBAL_MESSAGE",
      type,
      content: msg,
      duration
    })
  };

  const showSuccess = (msg?: string) => {
    showMessage(msg || 'Thành công', "success");
  };

  const showClientError = (msg?: string) => {
    let currentMessage = msg || 'Có lỗi xảy ra';
    const errorText = 'Lỗi người dùng' + " --> " + currentMessage;
    showMessage(msg || errorText, "error", 1.5);
  };
  const showInfo = (msg: string) => {
    showMessage(msg, "info", 1.5);
  };

  function showError(message?: string) {
    let currentMessage = message || 'Có lỗi xảy ra';
    const errorText = 'Lỗi hệ thống' + " --> " + currentMessage;
    showMessage(errorText || 'Lỗi hệ thống', "error", 2);
  }

  const toaster = {
    showSuccess,
    showError,
    showClientError,
    showInfo,
  };

  return {
    isLoading,
    setLoading,
    ...toaster,
  };
}
